export const shortSliceId = (id: string): string =>
  id.split("-")[0].replace("$", "_");

export const sliceAnchor = (slice: { id?: string; slice_type: string }) =>
  slice.id ? shortSliceId(slice.id) : slice.slice_type;
